const NS = 'NumberSuffixFilter';

export default function NumberSuffixFilter() {
  const suffixes = ["th", "st", "nd", "rd"];

  return function (number) {
    const relevantDigits = (number < 30) ? number % 20 : number % 30;
    const suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
    return number + suffix;
  };
}
